import { useState, useCallback } from 'react';
export const useManualRerender = () => {
    const [renderCount, updateRenderCount] = useState(0);
    return useCallback((params) => {
        const { delay } = params || {};
        if (delay) {
            const delayArray = Array.isArray(delay) ? delay : [delay];
            for (const timeout of delayArray) {
                setTimeout(() => {
                    updateRenderCount((renderCount) => renderCount + 1);
                }, timeout);
            }
        }
        else {
            updateRenderCount(renderCount + 1);
        }
    }, [renderCount, updateRenderCount]);
};
